<template>
  <div class="tw:hidden!" :data-loading="props.loading"></div>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    class="elevation-1 top-queries-by-clicks-table"
    :loading="props.loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ props.title }}</v-toolbar-title>
      </v-toolbar>
    </template>

    <template v-slot:item.impressions.value="{ item }">
      <div class="d-flex align-center">
        <span class="mr-2">{{ formatNumber(item.impressions.value) }}</span>
      </div>
    </template>

    <template v-slot:item.impressions.change="{ item }">
      <span :class="item.impressions.change >= 0 ? 'success--text' : 'error--text'">
        {{ item.impressions.change >= 0 ? "▲" : "▼" }}
        {{ formatNumber(Math.abs(item.impressions.change)) }}%
      </span>
    </template>

    <template v-slot:item.urlClicks.value="{ item }">
      <div class="d-flex align-center">
        <span class="mr-2">{{ formatNumber(item.urlClicks.value) }}</span>
      </div>
    </template>

    <template v-slot:item.urlClicks.change="{ item }">
      <span :class="item.urlClicks.change >= 0 ? 'success--text' : 'error--text'">
        {{ item.urlClicks.change >= 0 ? "▲" : "▼" }}
        {{ formatNumber(Math.abs(item.urlClicks.change)) }}%
      </span>
    </template>

    <template v-slot:item.urlCtr.value="{ item }">
      {{ formatNumber(item.urlCtr.value) }}
    </template>

    <template v-slot:item.urlCtr.change="{ item }">
      <span :class="item.urlCtr.change >= 0 ? 'success--text' : 'error--text'">
        {{ item.urlCtr.change >= 0 ? "▲" : "▼" }}
        {{ formatNumber(Math.abs(item.urlCtr.change)) }}%
      </span>
    </template>

    <template v-slot:item.avgPosition.value="{ item }">
      {{ formatNumber(item.avgPosition.value) }}
    </template>

    <template v-slot:item.avgPosition.change="{ item }">
      <span :class="item.avgPosition.change >= 0 ? 'success--text' : 'error--text'">
        {{ item.avgPosition.change >= 0 ? "▲" : "▼" }}
        {{ formatNumber(Math.abs(item.avgPosition.change)) }}%
      </span>
    </template>
  </v-data-table>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { type IAnalyticsData } from "@/types";
import _ from "lodash";
import { formatNumber } from "@/utils";

interface ITopQueriesByClickChartProps {
  data: IAnalyticsData.IGoogleSearchConsoleQueryPage[];
  item: "query" | "page";
  itemName: "Query" | "Page";
  title: string;
  loading: boolean;
}
const props = defineProps<ITopQueriesByClickChartProps>();

const search = ref("");

const headers = [
  { title: props.itemName, key: "item", align: "start" as const, width: "350px" },
  { title: "Impressions", key: "impressions.value", align: "center" as const },
  { title: "% Δ", key: "impressions.change", align: "center" as const },
  { title: "Clicks", key: "urlClicks.value", align: "center" as const },
  { title: "% Δ", key: "urlClicks.change", align: "center" as const },
  { title: "CTR", key: "urlCtr.value", align: "center" as const },
  { title: "% Δ", key: "urlCtr.change", align: "center" as const },
  { title: "Average Position", key: "avgPosition.value", align: "center" as const },
  { title: "% Δ", key: "avgPosition.change", align: "center" as const }
];

const items = computed(() =>
  _.map(props.data, (item) => ({
    item: item.item,
    impressions: {
      value: item.curr.impressions,
      change:
        item.compared.impressions === 0
          ? 1
          : item.change.impressions / Math.abs(item.compared.impressions)
    },
    urlClicks: {
      value: item.curr.clicks,
      change: item.compared.clicks === 0 ? 1 : item.change.clicks / item.compared.clicks
    },
    urlCtr: {
      value: Number(item.curr.ctr),
      change:
        Number(item.compared.ctr) === 0 ? 1 : Number(item.change.ctr) / Number(item.compared.ctr)
    },
    avgPosition: {
      value: item.curr.position,
      change: item.compared.position === 0 ? 1 : item.change.position / item.compared.position
    }
  }))
);
</script>

<style scoped>
.bar-bg {
  height: 16px;
  border-radius: 2px;
}
</style>
